import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

type Props = {
  children: React.ReactNode;
  intervalDelay?: number;
  className?: string;
  style?: React.CSSProperties;
};

const ScrollReveal: React.FC<Props> = ({ children, intervalDelay, className, style }) => {
  const [hasRevealed, setHasRevealed] = useState(false);
  const handleChange = (isVisible: boolean) => {
    if (isVisible) setHasRevealed(true);
  };
  return (
    <VisibilitySensor
      partialVisibility
      minTopValue={0}
      delayedCall
      onChange={handleChange}
      intervalDelay={intervalDelay}
    >
      <div className={`${className ? className : ''} reveal-animation ${hasRevealed ? 'activated' : ''}`} style={style}>
        {children}
      </div>
    </VisibilitySensor>
  );
};

export default ScrollReveal;
